import { useGlobalAuth } from '@headbox-ui/auth-hook'
import React, { useEffect, FC, ReactNode } from 'react'
import { GUEST_PROPOSALS_PATH, LOGIN_LINK, ROUTES } from '../../Constants'
import * as Sentry from '@sentry/react'
import { sendUserToProductFruits } from '../../Utilities/productFruits'

interface CompProps {
  children: ReactNode
}

const shouldRedirectToAuthentication = (pathname: string): boolean => {
  const { EVENT_HUB } = ROUTES

  const ROUTES_REQUIRE_AUTHENTICATION = [EVENT_HUB]

  const pathSegments = pathname !== '' ? pathname.split('/') : []

  let routesRequiringAuthenticationWithAppendedSegment: string[] = []

  if (pathSegments.length > 1 && '/' + pathSegments[1] === GUEST_PROPOSALS_PATH) {
    routesRequiringAuthenticationWithAppendedSegment = ROUTES_REQUIRE_AUTHENTICATION.map(
      (route) => GUEST_PROPOSALS_PATH + route
    )
  } else {
    routesRequiringAuthenticationWithAppendedSegment = ROUTES_REQUIRE_AUTHENTICATION
  }

  const formattedPathname = pathname.endsWith('/') ? pathname : pathname + '/'

  return routesRequiringAuthenticationWithAppendedSegment.includes(formattedPathname)
}

const Authenticator: FC<CompProps> = ({ children }) => {
  const { authenticated, user, loading } = useGlobalAuth()
  const { pathname = '' } = window ? window.location : {}

  useEffect(() => {
    if (user) {
      Sentry.configureScope((scope) => {
        scope.setUser({
          id: String(user.id),
          email: user.email,
          roles: user.roles
        })
      })
      sendUserToProductFruits(user)
    }
  }, [user])

  useEffect(() => {
    if (!loading && !authenticated && shouldRedirectToAuthentication(pathname)) {
      window.location.assign(LOGIN_LINK)
    }
  }, [authenticated])

  return <>{children}</>
}

export default Authenticator
